/**
 * Story 219 (RN5/RN6, contract §2): the component filter of the planned-jobs lists. The identity of
 * a component is its FULL `code` as `GET mos/components` delivers it -- never derived from the text
 * the operator reads (`"<code> - <name>"`), which a code may itself contain.
 */

/** "No component chosen": the lists are not filtered by component (RN1). */
export const NO_COMPONENT = ''

/**
 * The path segment of a component for the lists that accept one -- the ONLY way a code enters a
 * route. The whole code travels as one segment encoded as a URI component (R1), so hyphens, spaces,
 * `#`, `?`, `&`, `+` and non-ASCII characters reach Sun intact. Nothing without a component, so the
 * route is exactly the one of today (V2: never an empty segment).
 *
 * @param {string} code
 * @returns {string}
 */
export const componentPathSegment = (code) => (code === NO_COMPONENT ? '' : '/' + encodeURIComponent(code))

const hasCode = (entry) => typeof entry?.code === 'string' && entry.code.trim() !== ''

/**
 * The options of the "Component" field out of the catalog (RN6): one per code -- Sun already sends
 * them unique, so no name is consolidated here -- with the visible text `"<code> - <name>"`, or just
 * the code without a name (RN6.1). An entry without code is dropped (it could not filter), and a body
 * that is not a list gives no options (V3).
 *
 * The option deliberately has no `name`: `SmartSelect` keys and sorts an object option by its `name`
 * first, so two codes sharing a name would collide and sort by name instead of by the visible text
 * (RN6.2, `impacto.md` R6).
 *
 * @param {*} raw - The body of `GET mos/components`.
 * @returns {{code: string, label: string}[]}
 */
export const toComponentOptions = (raw) => {
  if (!Array.isArray(raw)) return []
  return raw.filter(hasCode).map(({ code, name }) => ({ code, label: name ? `${code} - ${name}` : code }))
}
